import { AnswerVehicle } from '../interfaces/interface.vehicle';
import EventBus from '../services/service.eventBus';
import { VehicleEligibility, fetchVehicleEligibility } from '../services/services.eligibility';
import { state as answerState } from '../store/store.answers';
import { state as landingState } from '../store/store.landing';
import { MAX_MILEAGE, MIN_MILEAGE } from '../utils/utils.vehicle';

export const checkVehicleEligibility = async (trimId: number, mileage: number, engineId?: number, drivetrainId?: number, transmissionId?: number): Promise<boolean> => {
  try {
    return await onFetchVehicleEligibilitySuccess(trimId, mileage, engineId, drivetrainId, transmissionId);
  } catch (error) {
    onFetchVehicleEligibilityFail(error);
    return false;
  }
};

export const onFetchVehicleEligibilitySuccess = async (trimId: number, mileage: number, engineId?: number, drivetrainId?: number, transmissionId?: number): Promise<boolean> => {
  const isUnassignedOffer = !landingState.isAssignedOffer;
  if (mileage <= MIN_MILEAGE || (mileage > MAX_MILEAGE && isUnassignedOffer)) {
    return false;
  }

  const eligibilityRec: VehicleEligibility = await fetchVehicleEligibility(trimId);

  let isEligible = true;
  if (eligibilityRec.isEligible !== true) {
    isEligible = false;
  }
  if (engineId !== undefined && eligibilityRec.excludedEngines.includes(engineId)) {
    isEligible = false;
  }
  if (drivetrainId !== undefined && eligibilityRec.excludedDrivetrains.includes(drivetrainId)) {
    isEligible = false;
  }
  if (transmissionId !== undefined && eligibilityRec.excludedTransmissions.includes(transmissionId)) {
    isEligible = false;
  }

  EventBus.publish('FetchVehicleEligibilitySuccess', eligibilityRec);
  return isEligible;
};

export const onFetchVehicleEligibilityFail = (error) => {
  EventBus.publish('FetchVehicleEligibilityFail', error);
};

export const autocheckIsIneligible = () => {
  const ineligible = {};
  const { isSalvage, hasFloodDamage, hasFrameDamage, previouslyCanadian, notActualMileage, isAutocheckAuctionEligible } = answerState.other;
  if (isSalvage.value) {
    ineligible['salvage'] = true;
  }
  if (hasFloodDamage.value) {
    ineligible['hasFloodDamage'] = true;
  }
  if (hasFrameDamage.value) {
    ineligible['hasFrameDamage'] = true;
  }
  if (previouslyCanadian.value) {
    ineligible['previouslyCanadian'] = true;
  }
  if (notActualMileage.value) {
    ineligible['notActualMileage'] = true;
  }
  if (!isAutocheckAuctionEligible.value) {
    ineligible['isAutocheckAuctionEligible'] = false;
  }
  if (Object.keys(ineligible).length === 0) {
    return false;
  }
  return true;
};

export const onUseTradeInValueEvent = (vehicle: AnswerVehicle, ineligibleReason: string): void => {
  const { yearId, makeId, make, modelId, model, trimId, trim, vin } = vehicle;
  const payload = {
    year: yearId,
    makeId,
    make,
    modelId,
    model,
    trimId,
    trim,
    vin: vin.length > 0 ? vin : null,
    ineligibleReason: ineligibleReason.length > 0 ? ineligibleReason.split(',') : null,
  };

  // remove any item with null value from payload
  Object.keys(payload).forEach((key) => {
    if (payload[key] === null) {
      delete payload[key];
    }
  });
  EventBus.publish('DRIneligibleUseTradeInValue', payload);
};
